import React, { useState } from 'react';

const Terms = () => {
  const [activeSection, setActiveSection] = useState('terms');

  const sections = {
    terms: {
      title: 'Terms of Service',
      content: `Our Terms of Service outline the rules and guidelines for using our platform. By accessing our services, you agree to comply with these terms and all applicable laws and regulations.

We reserve the right to modify these terms at any time. Your continued use of the platform following any changes constitutes acceptance of those changes.

Users are responsible for maintaining the confidentiality of their account information. You are solely responsible for all activity that occurs under your account.

You retain all rights to the content you upload. However, by uploading content, you grant us a license to use, modify, and display that content in connection with our services.

We may terminate accounts that violate our terms or are inactive for extended periods. Upon termination, your right to access our services will immediately cease.`
    },
    privacy: {
      title: 'Privacy & Cookie Policy',
      content: `We collect information that you provide directly to us, such as your name, email address, and any content you upload. We also automatically collect certain information about your device and how you interact with our platform.

Your information is used to provide and improve our services, communicate with you, and ensure security of our platform.

We use cookies and similar technologies to enhance your experience, analyze usage, and assist in our marketing efforts. You can control cookies through your browser settings.

We may share your information with third-party service providers who perform services on our behalf, when required by law, or in connection with a business transaction.

We implement reasonable security measures to protect your information, but no method of transmission over the Internet is 100% secure.

You can access, update, or delete your personal information through your account settings. For any privacy concerns, please contact us.`
    },
    refund: {
      title: 'Refund Policy',
      content: `Our platform operates on an image credits system. Credits are used to upload and store photos beyond the free tier limits.

Refunds may be granted for technical issues that prevent the service from functioning as intended. In such cases, please contact our support team within 7 days of purchase.

We do not offer refunds for unused credits, expired subscriptions, or if you simply change your mind. All sales are final unless otherwise specified.

If approved, refunds will be processed using the original payment method and may take 5-10 business days to appear on your statement.`
    }
  };

  return (
    <div className="min-h-screen bg-white pt-32">
      <div className="max-w-5xl mx-auto px-4 py-8">
        <div className="border-b border-gray-100 pb-8 mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Legal Information</h1>
          <p className="text-gray-600 mt-2">Please review our policies carefully before using our services</p>
        </div>
        
        <div className="flex flex-col md:flex-row gap-8">
          {/* Left Menu */}
          <div className="md:w-64 flex-shrink-0">
            <div className="space-y-1">
              {Object.entries(sections).map(([key, section]) => (
                <button
                  key={key}
                  onClick={() => setActiveSection(key)}
                  className={`w-full text-left px-4 py-3 rounded-md transition-colors ${
                    activeSection === key
                      ? 'bg-[#FF4444]/5 text-[#FF4444] font-medium'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {section.title}
                </button>
              ))}
            </div>
          </div>

          {/* Content Area */}
          <div className="flex-grow">
            <div className="border-b border-gray-100 pb-6 mb-6">
              <h2 className="text-2xl font-bold text-gray-900">
                {sections[activeSection as keyof typeof sections].title}
              </h2>
            </div>
            <div className="prose max-w-none">
              {sections[activeSection as keyof typeof sections].content.split('\n\n').map((paragraph, index) => (
                <div key={index} className="mb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {paragraph}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-100 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-500">
            Last updated: July 15, 2024 • <a href="mailto:support@ourphotos.com" className="text-[#FF4444] hover:underline">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;